












































import { defineComponent, PropType } from '@vue/composition-api';

import authMixin from '@/mixins/auth';
import { IBankPaymentInstructionData } from '@/models';
import PaymentInstructionOptionsButton from './PaymentInstructionOptionsButton.vue';
import PaymentInstructionPropertyList from './PaymentInstructionPropertyList.vue';

export default defineComponent({
  name: 'PaymentInstructionListItem',
  components: {
    PaymentInstructionOptionsButton,
    PaymentInstructionPropertyList
  },
  mixins: [authMixin],
  props: {
    paymentInstruction: {
      type: Object as PropType<IBankPaymentInstructionData>,
      required: true
    }
  }
});
